import { render, staticRenderFns } from "./NewHeader.vue?vue&type=template&id=42ada502&"
import script from "./NewHeader.vue?vue&type=script&lang=js&"
export * from "./NewHeader.vue?vue&type=script&lang=js&"
import style0 from "./NewHeader.vue?vue&type=style&index=0&id=42ada502&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports